import { EnfantModel } from '../../02-declaration-enfant/components/enfant/models/enfant.model';
import { InfoLongementForm, LogementModel } from '../components/info-logement/models/logement.model';
import { SitFamForm, SitFamModel } from '../components/sitfam/models/sitfam.model';
import { PersonneModel } from '../components/personne/models/personne.model';
import { FormGroup } from '@angular/forms';
import { PersonnesForm } from '../components/personnes/models/personnes.model';

export class DeclarationModel {

    logement: LogementModel
    sitFam: SitFamModel
    listePersonnes : Array<PersonneModel>;
    listeEnfants: Array<EnfantModel>;
    
    constructor(
        logement: LogementModel, 
        sitFam: SitFamModel,
        listePersonnes : Array<PersonneModel>) {
            
        this.logement = logement;
        this.sitFam = sitFam;
        this.listePersonnes = listePersonnes;
    }

}

export class DeclarationForm {
    infoLogement?:FormGroup<InfoLongementForm>;
    sitFam?:FormGroup<SitFamForm>;
    personnes?:FormGroup<PersonnesForm>;
}
